var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE2A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.06 29.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.24,13.74l-8-6.45c-.57-.46-1.74-.21-1.73.54,0,1.71-.12,8.11,0,13.1,0,.67,1.13,1,1.74.52l8-6.46a.78.78,0,0,0,0-1.25Z",
    fill: "#ed7333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.53,1.87A12.66,12.66,0,1,1,1.87,14.53,12.65,12.65,0,0,1,14.53,1.87ZM29.06,14.53A14.53,14.53,0,1,0,14.53,29.06,14.53,14.53,0,0,0,29.06,14.53Z",
    fill: "#ed7333",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2A);
export default __webpack_public_path__ + "static/media/E2A.709b699057f74f730c0416eb77e3ce9e.svg";
export { ForwardRef as ReactComponent };